<template>
  <vuex-table
    table_store="pbx/time-conditions/table"
    :fields="fields"
    :table_class="['table--content-middle']"
  >
    <template slot="name" slot-scope="{ item }">
      <router-link :to="{ name: 'pbx.time-condition.edit', params: { id: item.id } }">
        {{ item.name }}
      </router-link>
    </template>

    <template slot="worktimes" slot-scope="{ item }">
      <work-time-list-collapse :items="item.worktimes" />
    </template>

    <template slot="actions" slot-scope="{ item }">
      <table-control type="trash" @click="remove_item(item)" />
    </template>
  </vuex-table>
</template>

<script>
  import WorkTimeListCollapse from '@pbx/components/time-conditions/_fragments/worktime/list-collapse';
  import { mapActions } from 'vuex';
  import { TimeConditionModalService } from '@pbx/modals/TimeConditionModalService';

  export default {
    components: {
      WorkTimeListCollapse
    },

    computed: {
      fields: function() {
        return [
          {
            key: 'name',
            label: this.$t('shared.component.table.field.name'),
            sortable: true
          },
          {
            key: 'timezone',
            label: this.$t('pbx.time-condition.table.field.timezone'),
            sortable: true
          },
          {
            key: 'worktimes',
            label: this.$t('pbx.group.form.field.work_time'),
            sortable: false,
            class: 'w-25'
          },
          {
            key: 'actions',
            label: this.$t('shared.component.table.actions'),
            sortable: false,
            class: 'text-center'
          }
        ];
      }
    },

    methods: {
      ...mapActions('pbx/time-conditions/table', ['getAsyncData']),

      remove_item: function(item) {
        TimeConditionModalService.remove(item.id, item).on('success', () => this.getAsyncData());
      }
    }
  };
</script>
